import { render, staticRenderFns } from "./infor-detail.vue?vue&type=template&id=7f5b5b16&scoped=true"
import script from "./infor-detail.vue?vue&type=script&lang=js"
export * from "./infor-detail.vue?vue&type=script&lang=js"
import style0 from "./infor-detail.vue?vue&type=style&index=0&id=7f5b5b16&prod&scoped=true&lang=less"
import style1 from "./infor-detail.vue?vue&type=style&index=1&id=7f5b5b16&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5b5b16",
  null
  
)

export default component.exports